import type { FC, ReactNode } from "react";

import { Toggle } from "@jti/core-components";

import type { ToggleFieldConfig } from "@checkout-v2/formFields/components/ToggleField/ToggleField.types";

import styles from "./ToggleField.module.scss";

export type ToggleFieldProps = {
  fieldConfig: ToggleFieldConfig;
  value: boolean;
  dataTestId?: string;
  onChange: (value: boolean) => void;
  children?: ReactNode;
};

export const ToggleField: FC<ToggleFieldProps> = ({ fieldConfig, value, dataTestId, onChange, children }) => (
  <div className={styles.toggle}>
    <span id={`label-${fieldConfig.name}`}>{fieldConfig.label}</span>
    <div className={styles.control}>
      <Toggle
        id={fieldConfig.name}
        checked={value}
        data-testid={dataTestId}
        onChange={onChange}
        aria-labelledby={`label-${fieldConfig.name}`}
      />
      {children}
    </div>
  </div>
);
